import {
  EmailMessage,
  MessageParticipantType,
} from "@/utils/graphQL/queries/threads/shared"
import MessageTableItemView from "./MessageTableItemView"

const MessageTableView = ({
  messages,
  title,
}: {
  messages: EmailMessage[]
  title?: string
}) => {
  return (
    <div className="w-full">
      {/* Message Thread */}
      <div>
        {messages &&
          [...messages].reverse().map((message, idx) => {
            const originalIndex = messages.length - 1 - idx
            const metadataProvided = message.metadata

            // Handle both data structures - old (recipients array) and new (authorMember/destinationMembers)
            let sender: string[] = ["unknown"]
            let receiver: string[] = ["unknown"]
            let cc: string[] = []
            let bcc: string[] = []

            if (metadataProvided) {
              if (message.metadata.authorMember) {
                // New format
                sender = [message.metadata.authorMember.email]

                if (
                  message.metadata.destinationMembers &&
                  message.metadata.destinationMembers.length > 0
                ) {
                  receiver = message.metadata.destinationMembers.map(
                    (member) => member.email
                  )
                }
              } else if (message.metadata.recipients) {
                // Old format
                sender = message.metadata.recipients
                  .filter(
                    (recipient) =>
                      recipient.type === MessageParticipantType.from
                  )
                  .map((recipient) => recipient.email)

                receiver = message.metadata.recipients
                  .filter(
                    (recipient) =>
                      recipient.type === MessageParticipantType.recipient
                  )
                  .map((recipient) => recipient.email)

                cc = message.metadata.recipients
                  .filter(
                    (recipient) => recipient.type === MessageParticipantType.cc
                  )
                  .map((recipient) => recipient.email)

                bcc = message.metadata.recipients
                  .filter(
                    (recipient) => recipient.type === MessageParticipantType.bcc
                  )
                  .map((recipient) => recipient.email)
              }
            }

            return (
              <MessageTableItemView
                sender={sender}
                receiver={receiver}
                subject={message.subject}
                message={message.message}
                raw_content={message.raw_content}
                sentAt={message.sent_at}
                cc={cc}
                bcc={bcc}
                idx={originalIndex}
                key={originalIndex}
              />
            )
          })}
      </div>
    </div>
  )
}

export default MessageTableView
